import React from 'react';
import IconLink from "./IconLink";
import {Box} from "@mui/material";
import Style from './PortfolioBlock.module.scss';


function PortfolioBlock(props) {
   const {image, source, title, description} = props;
   return (
      <Box className={Style.container}>
         <Box className={Style.imageWrapper}>
            <Box component={'img'} src={image} alt={title} className={Style.image}/>
         </Box>
         <Box className={Style.content}>
            <h3 className={Style.title}>{title}</h3>
            <p className={Style.description}>{description}</p>
            <Box className={Style.links}>
                <IconLink link={source} title={'View Project'}/>
            </Box>
         </Box>
      </Box>
   );
}

export default PortfolioBlock;
